export const environment = {
  production: false,
  paginationSize: 2000,
  url: "https://i4y-dev-notifier.ew.r.appspot.com/"
  //url: "http://localhost:8090/"
};